module.exports = __webpack_public_path__ + "img/logo.c421501f.svg";